"use strict";
// Latest version of the SDK that does not use Anchor. It supports raw instructions.
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var bn_js_1 = __importDefault(require("bn.js"));
var buffer_1 = require("buffer");
var bs58_1 = __importDefault(require("bs58"));
var spl_token_1 = require("@solana/spl-token");
var web3_js_1 = require("@solana/web3.js");
var types_1 = require("./types");
var utils_1 = require("./utils");
var constants_1 = require("./constants");
var instructions_1 = require("./instructions");
var types_2 = require("../common/types");
var BaseStreamClient_1 = require("../common/BaseStreamClient");
var METADATA_ACC_SIZE = 1104;
var SolanaStreamClient = /** @class */ (function (_super) {
    __extends(SolanaStreamClient, _super);
    /**
     * Create Stream instance
     */
    function SolanaStreamClient(clusterUrl, cluster, commitment, programId) {
        if (cluster === void 0) { cluster = types_2.ICluster.Mainnet; }
        if (commitment === void 0) { commitment = "confirmed"; }
        if (programId === void 0) { programId = ""; }
        var _this = _super.call(this) || this;
        _this.commitment = commitment;
        _this.connection = new web3_js_1.Connection(clusterUrl, _this.commitment);
        _this.programId =
            programId !== "" ? new web3_js_1.PublicKey(programId) : new web3_js_1.PublicKey(constants_1.PROGRAM_ID[cluster]);
        return _this;
    }
    SolanaStreamClient.prototype.getConnection = function () {
        return this.connection;
    };
    SolanaStreamClient.prototype.getProgramId = function () {
        return this.programId.toBase58();
    };
    /**
     * Creates a new stream/vesting contract.
     * All fees are paid by sender (escrow metadata account rent, escrow token account rent, recipient's associated token account rent, Streamflow's service fee).
     */
    SolanaStreamClient.prototype.create = function (_a, _b) {
        var recipient = _a.recipient, mint = _a.tokenId, start = _a.start, depositedAmount = _a.amount, period = _a.period, cliff = _a.cliff, cliffAmount = _a.cliffAmount, amountPerPeriod = _a.amountPerPeriod, name = _a.name, canTopup = _a.canTopup, cancelableBySender = _a.cancelableBySender, cancelableByRecipient = _a.cancelableByRecipient, transferableBySender = _a.transferableBySender, transferableByRecipient = _a.transferableByRecipient, _c = _a.automaticWithdrawal, automaticWithdrawal = _c === void 0 ? false : _c, _d = _a.withdrawalFrequency, withdrawalFrequency = _d === void 0 ? 0 : _d, partner = _a.partner;
        var sender = _b.sender, _e = _b.isNative, isNative = _e === void 0 ? false : _e;
        return __awaiter(this, void 0, void 0, function () {
            var ixs, mintPublicKey, recipientPublicKey, metadata, _f, escrowTokens, senderTokens, recipientTokens, streamflowTreasuryTokens, partnerPublicKey, partnerTokens, nativeInstructions, _g, commitment, hash, tx, signature;
            var _h;
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        if (!sender.publicKey) {
                            throw new Error("Sender's PublicKey is not available, check passed wallet adapter!");
                        }
                        ixs = [];
                        mintPublicKey = isNative ? spl_token_1.NATIVE_MINT : new web3_js_1.PublicKey(mint);
                        recipientPublicKey = new web3_js_1.PublicKey(recipient);
                        metadata = web3_js_1.Keypair.generate();
                        return [4 /*yield*/, web3_js_1.PublicKey.findProgramAddress([buffer_1.Buffer.from("strm"), metadata.publicKey.toBuffer()], this.programId)];
                    case 1:
                        _f = __read.apply(void 0, [_j.sent(), 1]), escrowTokens = _f[0];
                        return [4 /*yield*/, (0, utils_1.ata)(mintPublicKey, sender.publicKey)];
                    case 2:
                        senderTokens = _j.sent();
                        return [4 /*yield*/, (0, utils_1.ata)(mintPublicKey, recipientPublicKey)];
                    case 3:
                        recipientTokens = _j.sent();
                        return [4 /*yield*/, (0, utils_1.ata)(mintPublicKey, constants_1.STREAMFLOW_TREASURY_PUBLIC_KEY)];
                    case 4:
                        streamflowTreasuryTokens = _j.sent();
                        partnerPublicKey = partner ? new web3_js_1.PublicKey(partner) : constants_1.STREAMFLOW_TREASURY_PUBLIC_KEY;
                        return [4 /*yield*/, (0, utils_1.ata)(mintPublicKey, partnerPublicKey)];
                    case 5:
                        partnerTokens = _j.sent();
                        if (!isNative) return [3 /*break*/, 7];
                        return [4 /*yield*/, (0, instructions_1.prepareWrappedAccount)(this.connection, sender.publicKey, depositedAmount)];
                    case 6:
                        _g = _j.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        _g = [];
                        _j.label = 8;
                    case 8:
                        nativeInstructions = _g;
                        ixs.push((0, instructions_1.createStreamInstruction)({
                            start: new bn_js_1.default(start),
                            depositedAmount: depositedAmount,
                            period: new bn_js_1.default(period),
                            amountPerPeriod: amountPerPeriod,
                            cliff: new bn_js_1.default(cliff),
                            cliffAmount: cliffAmount,
                            cancelableBySender: cancelableBySender,
                            cancelableByRecipient: cancelableByRecipient,
                            automaticWithdrawal: automaticWithdrawal,
                            transferableBySender: transferableBySender,
                            transferableByRecipient: transferableByRecipient,
                            canTopup: canTopup,
                            name: name,
                            withdrawFrequency: new bn_js_1.default(automaticWithdrawal ? withdrawalFrequency : period),
                        }, this.programId, {
                            sender: sender.publicKey,
                            senderTokens: senderTokens,
                            recipient: new web3_js_1.PublicKey(recipient),
                            metadata: metadata.publicKey,
                            escrowTokens: escrowTokens,
                            recipientTokens: recipientTokens,
                            streamflowTreasury: constants_1.STREAMFLOW_TREASURY_PUBLIC_KEY,
                            streamflowTreasuryTokens: streamflowTreasuryTokens,
                            partner: partnerPublicKey,
                            partnerTokens: partnerTokens,
                            mint: new web3_js_1.PublicKey(mint),
                            feeOracle: constants_1.FEE_ORACLE_PUBLIC_KEY,
                            rent: web3_js_1.SYSVAR_RENT_PUBKEY,
                            timelockProgram: this.programId,
                            tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                            associatedTokenProgram: spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID,
                            withdrawor: constants_1.WITHDRAWOR_PUBLIC_KEY,
                            systemProgram: web3_js_1.SystemProgram.programId,
                        }));
                        commitment = typeof this.commitment == "string" ? this.commitment : this.commitment.commitment;
                        return [4 /*yield*/, this.connection.getLatestBlockhash(commitment)];
                    case 9:
                        hash = _j.sent();
                        tx = (_h = new web3_js_1.Transaction({
                            feePayer: sender.publicKey,
                            blockhash: hash.blockhash,
                            lastValidBlockHeight: hash.lastValidBlockHeight,
                        })).add.apply(_h, __spreadArray(__spreadArray([], __read(nativeInstructions), false), __read(ixs), false));
                        tx.partialSign(metadata);
                        return [4 /*yield*/, this.sign(sender, tx, hash)];
                    case 10:
                        signature = _j.sent();
                        return [2 /*return*/, { ixs: ixs, txId: signature, metadataId: metadata.publicKey.toBase58() }];
                }
            });
        });
    };
    /**
     * Creates a new stream/vesting contract using unchecked instruction.
     *
     * Unchecked instruction differes from the regular in:
     * - does not check for initialized associated token account (wallets with no control over their ATA should not be used
     * as sender/recipient/partner or there are risks of funds being locked in the contract)
     * - initialized contract PDA off chain
     *
     * If you are not sure if you should use create or create_unchecked, go for create to be safer.
     */
    SolanaStreamClient.prototype.createUnchecked = function (_a, _b) {
        var recipient = _a.recipient, mint = _a.tokenId, start = _a.start, depositedAmount = _a.amount, period = _a.period, cliff = _a.cliff, cliffAmount = _a.cliffAmount, amountPerPeriod = _a.amountPerPeriod, name = _a.name, canTopup = _a.canTopup, cancelableBySender = _a.cancelableBySender, cancelableByRecipient = _a.cancelableByRecipient, transferableBySender = _a.transferableBySender, transferableByRecipient = _a.transferableByRecipient, _c = _a.automaticWithdrawal, automaticWithdrawal = _c === void 0 ? false : _c, _d = _a.withdrawalFrequency, withdrawalFrequency = _d === void 0 ? 0 : _d, partner = _a.partner;
        var sender = _b.sender, _e = _b.isNative, isNative = _e === void 0 ? false : _e;
        return __awaiter(this, void 0, void 0, function () {
            var mintPublicKey, recipientPublicKey, metadata, rentToExempt, createMetadataInstruction, _f, escrowTokens, senderTokens, partnerPublicKey, nativeInstructions, _g, createInstruction, commitment, ixs, hash, tx, signature;
            var _h;
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        if (!sender.publicKey) {
                            throw new Error("Sender's PublicKey is not available, check passed wallet adapter!");
                        }
                        mintPublicKey = new web3_js_1.PublicKey(mint);
                        recipientPublicKey = new web3_js_1.PublicKey(recipient);
                        metadata = web3_js_1.Keypair.generate();
                        return [4 /*yield*/, this.connection.getMinimumBalanceForRentExemption(METADATA_ACC_SIZE)];
                    case 1:
                        rentToExempt = _j.sent();
                        createMetadataInstruction = web3_js_1.SystemProgram.createAccount({
                            programId: this.programId,
                            space: METADATA_ACC_SIZE,
                            lamports: rentToExempt,
                            fromPubkey: sender === null || sender === void 0 ? void 0 : sender.publicKey,
                            newAccountPubkey: metadata.publicKey,
                        });
                        return [4 /*yield*/, web3_js_1.PublicKey.findProgramAddress([buffer_1.Buffer.from("strm"), metadata.publicKey.toBuffer()], this.programId)];
                    case 2:
                        _f = __read.apply(void 0, [_j.sent(), 1]), escrowTokens = _f[0];
                        return [4 /*yield*/, (0, utils_1.ata)(mintPublicKey, sender.publicKey)];
                    case 3:
                        senderTokens = _j.sent();
                        partnerPublicKey = partner ? new web3_js_1.PublicKey(partner) : constants_1.STREAMFLOW_TREASURY_PUBLIC_KEY;
                        if (!isNative) return [3 /*break*/, 5];
                        return [4 /*yield*/, (0, instructions_1.prepareWrappedAccount)(this.connection, sender.publicKey, depositedAmount)];
                    case 4:
                        _g = _j.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        _g = [];
                        _j.label = 6;
                    case 6:
                        nativeInstructions = _g;
                        createInstruction = (0, instructions_1.createUncheckedStreamInstruction)({
                            start: new bn_js_1.default(start),
                            depositedAmount: depositedAmount,
                            period: new bn_js_1.default(period),
                            amountPerPeriod: amountPerPeriod,
                            cliff: new bn_js_1.default(cliff),
                            cliffAmount: cliffAmount,
                            cancelableBySender: cancelableBySender,
                            cancelableByRecipient: cancelableByRecipient,
                            automaticWithdrawal: automaticWithdrawal,
                            transferableBySender: transferableBySender,
                            transferableByRecipient: transferableByRecipient,
                            canTopup: canTopup,
                            name: name,
                            withdrawFrequency: new bn_js_1.default(automaticWithdrawal ? withdrawalFrequency : period),
                            recipient: recipientPublicKey,
                            partner: partnerPublicKey,
                        }, this.programId, {
                            sender: sender.publicKey,
                            senderTokens: senderTokens,
                            metadata: metadata.publicKey,
                            escrowTokens: escrowTokens,
                            mint: new web3_js_1.PublicKey(mint),
                            feeOracle: constants_1.FEE_ORACLE_PUBLIC_KEY,
                            rent: web3_js_1.SYSVAR_RENT_PUBKEY,
                            timelockProgram: this.programId,
                            tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                            withdrawor: constants_1.WITHDRAWOR_PUBLIC_KEY,
                            systemProgram: web3_js_1.SystemProgram.programId,
                        });
                        commitment = typeof this.commitment == "string" ? this.commitment : this.commitment.commitment;
                        ixs = [createMetadataInstruction, createInstruction];
                        return [4 /*yield*/, this.connection.getLatestBlockhash(commitment)];
                    case 7:
                        hash = _j.sent();
                        tx = (_h = new web3_js_1.Transaction({
                            feePayer: sender.publicKey,
                            blockhash: hash.blockhash,
                            lastValidBlockHeight: hash.lastValidBlockHeight,
                        })).add.apply(_h, __spreadArray(__spreadArray([], __read(nativeInstructions), false), __read(ixs), false));
                        tx.partialSign(metadata);
                        return [4 /*yield*/, this.sign(sender, tx, hash)];
                    case 8:
                        signature = _j.sent();
                        return [2 /*return*/, { ixs: ixs, txId: signature, metadataId: metadata.publicKey.toBase58() }];
                }
            });
        });
    };
    /**
     * Creates multiple stream/vesting contracts.
     * All fees are paid by sender (escrow metadata account rent, escrow token account rent, recipient's associated token account rent, Streamflow's service fee).
     */
    SolanaStreamClient.prototype.createMultiple = function (data, _a) {
        var sender = _a.sender, _b = _a.isNative, isNative = _b === void 0 ? false : _b;
        return __awaiter(this, void 0, void 0, function () {
            var recipients, metadatas, metadataToRecipient, errors, signatures, batch, recipients_1, recipients_1_1, recipientData, _c, tx, metadata, metadataPubKey, e_1_1, totalDepositedAmount, nativeInstructions, commitment, hash, prepareTransaction, signedBatch, prepareTx, batchTransactionsCalls, responses, successes, failures, metadataIds;
            var e_1, _d, _e;
            var _this = this;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        recipients = data.recipients;
                        if (!sender.publicKey) {
                            throw new Error("Sender's PublicKey is not available, check passed wallet adapter!");
                        }
                        metadatas = [];
                        metadataToRecipient = {};
                        errors = [];
                        signatures = [];
                        batch = [];
                        _f.label = 1;
                    case 1:
                        _f.trys.push([1, 6, 7, 8]);
                        recipients_1 = __values(recipients), recipients_1_1 = recipients_1.next();
                        _f.label = 2;
                    case 2:
                        if (!!recipients_1_1.done) return [3 /*break*/, 5];
                        recipientData = recipients_1_1.value;
                        return [4 /*yield*/, this.prepareStreamTransaction(recipientData, data, {
                                sender: sender,
                            })];
                    case 3:
                        _c = _f.sent(), tx = _c.tx, metadata = _c.metadata;
                        metadataPubKey = metadata.publicKey.toBase58();
                        metadataToRecipient[metadataPubKey] = recipientData;
                        metadatas.push(metadata);
                        batch.push({ tx: tx, recipient: recipientData.recipient });
                        _f.label = 4;
                    case 4:
                        recipients_1_1 = recipients_1.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_1_1 = _f.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (recipients_1_1 && !recipients_1_1.done && (_d = recipients_1.return)) _d.call(recipients_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 8:
                        if (!isNative) return [3 /*break*/, 11];
                        totalDepositedAmount = recipients.reduce(function (acc, recipient) { return recipient.amount.add(acc); }, new bn_js_1.default(0));
                        return [4 /*yield*/, (0, instructions_1.prepareWrappedAccount)(this.connection, sender.publicKey, totalDepositedAmount)];
                    case 9:
                        nativeInstructions = _f.sent();
                        commitment = typeof this.commitment == "string" ? this.commitment : this.commitment.commitment;
                        return [4 /*yield*/, this.connection.getLatestBlockhash(commitment)];
                    case 10:
                        hash = _f.sent();
                        prepareTransaction = (_e = new web3_js_1.Transaction({
                            feePayer: sender.publicKey,
                            blockhash: hash.blockhash,
                            lastValidBlockHeight: hash.lastValidBlockHeight,
                        })).add.apply(_e, __spreadArray([], __read(nativeInstructions), false));
                        batch.push({ tx: prepareTransaction, recipient: sender.publicKey.toBase58() });
                        _f.label = 11;
                    case 11: return [4 /*yield*/, (0, utils_1.signAllTransactionWithRecipients)(sender, batch)];
                    case 12:
                        signedBatch = _f.sent();
                        signedBatch.forEach(function (item, index) {
                            item.tx.lastValidBlockHeight = batch[index].tx.lastValidBlockHeight;
                        });
                        if (!isNative) return [3 /*break*/, 14];
                        prepareTx = signedBatch.pop();
                        return [4 /*yield*/, (0, utils_1.sendAndConfirmStreamRawTransaction)(this.connection, prepareTx)];
                    case 13:
                        _f.sent();
                        _f.label = 14;
                    case 14:
                        batchTransactionsCalls = signedBatch.map(function (el) {
                            return (0, utils_1.sendAndConfirmStreamRawTransaction)(_this.connection, el);
                        });
                        return [4 /*yield*/, Promise.allSettled(batchTransactionsCalls)];
                    case 15:
                        responses = _f.sent();
                        successes = responses
                            .filter(function (el) { return el.status === "fulfilled"; })
                            .map(function (el) { return el.value; });
                        signatures.push.apply(signatures, __spreadArray([], __read(successes.map(function (el) { return el.signature; })), false));
                        failures = responses
                            .filter(function (el) { return el.status === "rejected"; })
                            .map(function (el) { return el.reason; });
                        errors.push.apply(errors, __spreadArray([], __read(failures), false));
                        metadataIds = metadatas.map(function (pk) { return pk.publicKey.toBase58(); });
                        return [2 /*return*/, { txs: signatures, metadatas: metadataIds, metadataToRecipient: metadataToRecipient, errors: errors }];
                }
            });
        });
    };
    /**
     * Attempts withdrawing from the specified stream.
     */
    SolanaStreamClient.prototype.withdraw = function (_a, _b) {
        var id = _a.id, amount = _a.amount;
        var invoker = _b.invoker;
        return __awaiter(this, void 0, void 0, function () {
            var ixs, streamPublicKey, escrow, data, streamflowTreasuryTokens, partnerTokens, commitment, hash, tx, signature;
            var _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!invoker.publicKey) {
                            throw new Error("Invoker's PublicKey is not available, check passed wallet adapter!");
                        }
                        ixs = [];
                        streamPublicKey = new web3_js_1.PublicKey(id);
                        return [4 /*yield*/, this.connection.getAccountInfo(streamPublicKey)];
                    case 1:
                        escrow = _d.sent();
                        if (!(escrow === null || escrow === void 0 ? void 0 : escrow.data)) {
                            throw new Error("Couldn't get account info");
                        }
                        data = (0, utils_1.decodeStream)(escrow.data);
                        return [4 /*yield*/, (0, utils_1.ata)(data.mint, constants_1.STREAMFLOW_TREASURY_PUBLIC_KEY)];
                    case 2:
                        streamflowTreasuryTokens = _d.sent();
                        return [4 /*yield*/, (0, utils_1.ata)(data.mint, data.partner)];
                    case 3:
                        partnerTokens = _d.sent();
                        ixs.push((0, instructions_1.withdrawStreamInstruction)(amount, this.programId, {
                            authority: invoker.publicKey,
                            recipient: invoker.publicKey,
                            recipientTokens: data.recipientTokens,
                            metadata: streamPublicKey,
                            escrowTokens: data.escrowTokens,
                            streamflowTreasury: constants_1.STREAMFLOW_TREASURY_PUBLIC_KEY,
                            streamflowTreasuryTokens: streamflowTreasuryTokens,
                            partner: data.partner,
                            partnerTokens: partnerTokens,
                            mint: data.mint,
                            tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                        }));
                        commitment = typeof this.commitment == "string" ? this.commitment : this.commitment.commitment;
                        return [4 /*yield*/, this.connection.getLatestBlockhash(commitment)];
                    case 4:
                        hash = _d.sent();
                        tx = (_c = new web3_js_1.Transaction({
                            feePayer: invoker.publicKey,
                            blockhash: hash.blockhash,
                            lastValidBlockHeight: hash.lastValidBlockHeight,
                        })).add.apply(_c, __spreadArray([], __read(ixs), false));
                        return [4 /*yield*/, this.sign(invoker, tx, hash)];
                    case 5:
                        signature = _d.sent();
                        return [2 /*return*/, { ixs: ixs, txId: signature }];
                }
            });
        });
    };
    /**
     * Attempts canceling the specified stream.
     */
    SolanaStreamClient.prototype.cancel = function (_a, _b) {
        var id = _a.id;
        var invoker = _b.invoker;
        return __awaiter(this, void 0, void 0, function () {
            var streamPublicKey, escrowAcc, data, streamflowTreasuryTokens, partnerTokens, ixs, commitment, hash, tx, signature;
            var _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!invoker.publicKey) {
                            throw new Error("Invoker's PublicKey is not available, check passed wallet adapter!");
                        }
                        streamPublicKey = new web3_js_1.PublicKey(id);
                        return [4 /*yield*/, this.connection.getAccountInfo(streamPublicKey)];
                    case 1:
                        escrowAcc = _d.sent();
                        if (!(escrowAcc === null || escrowAcc === void 0 ? void 0 : escrowAcc.data)) {
                            throw new Error("Couldn't get account info");
                        }
                        data = (0, utils_1.decodeStream)(escrowAcc === null || escrowAcc === void 0 ? void 0 : escrowAcc.data);
                        return [4 /*yield*/, (0, utils_1.ata)(data.mint, constants_1.STREAMFLOW_TREASURY_PUBLIC_KEY)];
                    case 2:
                        streamflowTreasuryTokens = _d.sent();
                        return [4 /*yield*/, (0, utils_1.ata)(data.mint, data.partner)];
                    case 3:
                        partnerTokens = _d.sent();
                        ixs = [];
                        ixs.push((0, instructions_1.cancelStreamInstruction)(this.programId, {
                            authority: invoker.publicKey,
                            sender: data.sender,
                            senderTokens: data.senderTokens,
                            recipient: data.recipient,
                            recipientTokens: data.recipientTokens,
                            metadata: streamPublicKey,
                            escrowTokens: data.escrowTokens,
                            streamflowTreasury: constants_1.STREAMFLOW_TREASURY_PUBLIC_KEY,
                            streamflowTreasuryTokens: streamflowTreasuryTokens,
                            partner: data.partner,
                            partnerTokens: partnerTokens,
                            mint: data.mint,
                            tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                        }));
                        commitment = typeof this.commitment == "string" ? this.commitment : this.commitment.commitment;
                        return [4 /*yield*/, this.connection.getLatestBlockhash(commitment)];
                    case 4:
                        hash = _d.sent();
                        tx = (_c = new web3_js_1.Transaction({
                            feePayer: invoker.publicKey,
                            blockhash: hash.blockhash,
                            lastValidBlockHeight: hash.lastValidBlockHeight,
                        })).add.apply(_c, __spreadArray([], __read(ixs), false));
                        return [4 /*yield*/, this.sign(invoker, tx, hash)];
                    case 5:
                        signature = _d.sent();
                        return [2 /*return*/, { ixs: ixs, txId: signature }];
                }
            });
        });
    };
    /**
     * Attempts changing the stream/vesting contract's recipient (effectively transferring the stream/vesting contract).
     * Potential associated token account rent fee (to make it rent-exempt) is paid by the transaction initiator.
     */
    SolanaStreamClient.prototype.transfer = function (_a, _b) {
        var id = _a.id, newRecipientString = _a.newRecipient;
        var invoker = _b.invoker;
        return __awaiter(this, void 0, void 0, function () {
            var ixs, stream, newRecipient, escrow, mint, newRecipientTokens, commitment, hash, tx, signature;
            var _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!invoker.publicKey) {
                            throw new Error("Invoker's PublicKey is not available, check passed wallet adapter!");
                        }
                        ixs = [];
                        stream = new web3_js_1.PublicKey(id);
                        newRecipient = new web3_js_1.PublicKey(newRecipientString);
                        return [4 /*yield*/, this.connection.getAccountInfo(stream)];
                    case 1:
                        escrow = _d.sent();
                        if (!(escrow === null || escrow === void 0 ? void 0 : escrow.data)) {
                            throw new Error("Couldn't get account info");
                        }
                        mint = (0, utils_1.decodeStream)(escrow === null || escrow === void 0 ? void 0 : escrow.data).mint;
                        return [4 /*yield*/, (0, utils_1.ata)(mint, newRecipient)];
                    case 2:
                        newRecipientTokens = _d.sent();
                        ixs.push((0, instructions_1.transferStreamInstruction)(this.programId, {
                            authority: invoker.publicKey,
                            newRecipient: newRecipient,
                            newRecipientTokens: newRecipientTokens,
                            metadata: stream,
                            mint: mint,
                            rent: web3_js_1.SYSVAR_RENT_PUBKEY,
                            tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                            associatedTokenProgram: spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID,
                            systemProgram: web3_js_1.SystemProgram.programId,
                        }));
                        commitment = typeof this.commitment == "string" ? this.commitment : this.commitment.commitment;
                        return [4 /*yield*/, this.connection.getLatestBlockhash(commitment)];
                    case 3:
                        hash = _d.sent();
                        tx = (_c = new web3_js_1.Transaction({
                            feePayer: invoker.publicKey,
                            blockhash: hash.blockhash,
                            lastValidBlockHeight: hash.lastValidBlockHeight,
                        })).add.apply(_c, __spreadArray([], __read(ixs), false));
                        return [4 /*yield*/, this.sign(invoker, tx, hash)];
                    case 4:
                        signature = _d.sent();
                        return [2 /*return*/, { ixs: ixs, txId: signature }];
                }
            });
        });
    };
    /**
     * Tops up stream account with specified amount.
     */
    SolanaStreamClient.prototype.topup = function (_a, _b) {
        var id = _a.id, amount = _a.amount;
        var invoker = _b.invoker, isNative = _b.isNative;
        return __awaiter(this, void 0, void 0, function () {
            var ixs, streamPublicKey, escrow, _c, mint, partner, senderTokens, escrowTokens, streamflowTreasuryTokens, partnerTokens, nativeInstructions, _d, commitment, hash, tx, signature;
            var _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        if (!invoker.publicKey) {
                            throw new Error("Invoker's PublicKey is not available, check passed wallet adapter!");
                        }
                        ixs = [];
                        streamPublicKey = new web3_js_1.PublicKey(id);
                        return [4 /*yield*/, this.connection.getAccountInfo(streamPublicKey)];
                    case 1:
                        escrow = _f.sent();
                        if (!(escrow === null || escrow === void 0 ? void 0 : escrow.data)) {
                            throw new Error("Couldn't get account info");
                        }
                        _c = (0, utils_1.decodeStream)(escrow === null || escrow === void 0 ? void 0 : escrow.data), mint = _c.mint, partner = _c.partner, senderTokens = _c.senderTokens, escrowTokens = _c.escrowTokens;
                        return [4 /*yield*/, (0, utils_1.ata)(mint, constants_1.STREAMFLOW_TREASURY_PUBLIC_KEY)];
                    case 2:
                        streamflowTreasuryTokens = _f.sent();
                        return [4 /*yield*/, (0, utils_1.ata)(mint, partner)];
                    case 3:
                        partnerTokens = _f.sent();
                        if (!isNative) return [3 /*break*/, 5];
                        return [4 /*yield*/, (0, instructions_1.prepareWrappedAccount)(this.connection, invoker.publicKey, amount)];
                    case 4:
                        _d = _f.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        _d = [];
                        _f.label = 6;
                    case 6:
                        nativeInstructions = _d;
                        ixs.push((0, instructions_1.topupStreamInstruction)(amount, this.programId, {
                            sender: invoker.publicKey,
                            senderTokens: senderTokens,
                            metadata: streamPublicKey,
                            escrowTokens: escrowTokens,
                            streamflowTreasury: constants_1.STREAMFLOW_TREASURY_PUBLIC_KEY,
                            streamflowTreasuryTokens: streamflowTreasuryTokens,
                            partner: partner,
                            partnerTokens: partnerTokens,
                            mint: mint,
                            tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                            withdrawor: constants_1.WITHDRAWOR_PUBLIC_KEY,
                            systemProgram: web3_js_1.SystemProgram.programId,
                        }));
                        commitment = typeof this.commitment == "string" ? this.commitment : this.commitment.commitment;
                        return [4 /*yield*/, this.connection.getLatestBlockhash(commitment)];
                    case 7:
                        hash = _f.sent();
                        tx = (_e = new web3_js_1.Transaction({
                            feePayer: invoker.publicKey,
                            blockhash: hash.blockhash,
                            lastValidBlockHeight: hash.lastValidBlockHeight,
                        })).add.apply(_e, __spreadArray(__spreadArray([], __read(nativeInstructions), false), __read(ixs), false));
                        return [4 /*yield*/, this.sign(invoker, tx, hash)];
                    case 8:
                        signature = _f.sent();
                        return [2 /*return*/, { ixs: ixs, txId: signature }];
                }
            });
        });
    };
    /**
     * Fetch stream data by its id (address).
     */
    SolanaStreamClient.prototype.getOne = function (_a) {
        var id = _a.id;
        return __awaiter(this, void 0, void 0, function () {
            var escrow;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.connection.getAccountInfo(new web3_js_1.PublicKey(id), constants_1.TX_FINALITY_CONFIRMED)];
                    case 1:
                        escrow = _b.sent();
                        if (!(escrow === null || escrow === void 0 ? void 0 : escrow.data)) {
                            throw new Error("Couldn't get account info.");
                        }
                        return [2 /*return*/, new types_1.Contract((0, utils_1.decodeStream)(escrow === null || escrow === void 0 ? void 0 : escrow.data))];
                }
            });
        });
    };
    /**
     * Fetch streams/contracts by providing direction.
     * Streams are sorted by start time in ascending order.
     */
    SolanaStreamClient.prototype.get = function (_a) {
        var address = _a.address, _b = _a.type, type = _b === void 0 ? types_2.StreamType.All : _b, _c = _a.direction, direction = _c === void 0 ? types_2.StreamDirection.All : _c;
        return __awaiter(this, void 0, void 0, function () {
            var publicKey, accounts, outgoingAccounts, incomingAccounts, offset, streams, sortedStreams;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        publicKey = new web3_js_1.PublicKey(address);
                        accounts = [];
                        if (!(direction === "all")) return [3 /*break*/, 3];
                        return [4 /*yield*/, (0, utils_1.getProgramAccounts)(this.connection, publicKey, constants_1.STREAM_STRUCT_OFFSET_SENDER, this.programId)];
                    case 1:
                        outgoingAccounts = _d.sent();
                        return [4 /*yield*/, (0, utils_1.getProgramAccounts)(this.connection, publicKey, constants_1.STREAM_STRUCT_OFFSET_RECIPIENT, this.programId)];
                    case 2:
                        incomingAccounts = _d.sent();
                        accounts = __spreadArray(__spreadArray([], __read(outgoingAccounts), false), __read(incomingAccounts), false);
                        return [3 /*break*/, 5];
                    case 3:
                        offset = direction === "outgoing" ? constants_1.STREAM_STRUCT_OFFSET_SENDER : constants_1.STREAM_STRUCT_OFFSET_RECIPIENT;
                        return [4 /*yield*/, (0, utils_1.getProgramAccounts)(this.connection, publicKey, offset, this.programId)];
                    case 4:
                        accounts = _d.sent();
                        _d.label = 5;
                    case 5:
                        streams = {};
                        accounts.forEach(function (account) {
                            var _a;
                            var decoded = new types_1.Contract((0, utils_1.decodeStream)(account.account.data));
                            streams = __assign(__assign({}, streams), (_a = {}, _a[account.pubkey.toBase58()] = decoded, _a));
                        });
                        sortedStreams = Object.entries(streams).sort(function (_a, _b) {
                            var _c = __read(_a, 2), stream1 = _c[1];
                            var _d = __read(_b, 2), stream2 = _d[1];
                            return stream2.start - stream1.start;
                        });
                        if (type === "all")
                            return [2 /*return*/, sortedStreams];
                        return [2 /*return*/, sortedStreams.filter(function (stream) { return stream[1].type === type; })];
                }
            });
        });
    };
    SolanaStreamClient.prototype.sign = function (invoker, tx, hash) {
        return __awaiter(this, void 0, void 0, function () {
            var signedTx, rawTx, confirmationStrategy, signature;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(0, utils_1.isSignerWallet)(invoker)) return [3 /*break*/, 2];
                        return [4 /*yield*/, invoker.signTransaction(tx)];
                    case 1:
                        signedTx = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        tx.partialSign(invoker);
                        signedTx = tx;
                        _a.label = 3;
                    case 3:
                        rawTx = signedTx.serialize();
                        if (!hash.lastValidBlockHeight || !signedTx.signature || !hash.blockhash)
                            throw Error("Error with transaction parameters.");
                        confirmationStrategy = {
                            lastValidBlockHeight: hash.lastValidBlockHeight,
                            signature: bs58_1.default.encode(signedTx.signature),
                            blockhash: hash.blockhash,
                        };
                        return [4 /*yield*/, (0, web3_js_1.sendAndConfirmRawTransaction)(this.connection, rawTx, confirmationStrategy)];
                    case 4:
                        signature = _a.sent();
                        return [2 /*return*/, signature];
                }
            });
        });
    };
    /**
     * Attempts updating the stream auto withdrawal params and amount per period
     */
    SolanaStreamClient.prototype.update = function (data, _a) {
        var invoker = _a.invoker;
        return __awaiter(this, void 0, void 0, function () {
            var streamPublicKey, escrow, updateIx, commitment, hash, tx, signature;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!invoker.publicKey) {
                            throw new Error("Invoker's PublicKey is not available, check passed wallet adapter!");
                        }
                        streamPublicKey = new web3_js_1.PublicKey(data.id);
                        return [4 /*yield*/, this.connection.getAccountInfo(streamPublicKey)];
                    case 1:
                        escrow = _b.sent();
                        if (!escrow) {
                            throw new Error("Couldn't get account info");
                        }
                        updateIx = (0, instructions_1.updateStreamInstruction)(data, this.programId, {
                            authority: invoker.publicKey,
                            metadata: streamPublicKey,
                            withdrawor: constants_1.WITHDRAWOR_PUBLIC_KEY,
                            systemProgram: web3_js_1.SystemProgram.programId,
                        });
                        commitment = typeof this.commitment == "string" ? this.commitment : this.commitment.commitment;
                        return [4 /*yield*/, this.connection.getLatestBlockhash(commitment)];
                    case 2:
                        hash = _b.sent();
                        tx = new web3_js_1.Transaction({
                            feePayer: invoker.publicKey,
                            blockhash: hash.blockhash,
                            lastValidBlockHeight: hash.lastValidBlockHeight,
                        }).add(updateIx);
                        return [4 /*yield*/, this.sign(invoker, tx, hash)];
                    case 3:
                        signature = _b.sent();
                        return [2 /*return*/, {
                                ixs: [updateIx],
                                txId: signature,
                            }];
                }
            });
        });
    };
    /**
     * Forms instructions from params, creates a raw transaction and fetch recent blockhash.
     */
    SolanaStreamClient.prototype.prepareStreamTransaction = function (recipient, streamParams, solanaExtendedConfig) {
        return __awaiter(this, void 0, void 0, function () {
            var mint, start, period, cliff, canTopup, cancelableBySender, cancelableByRecipient, transferableBySender, transferableByRecipient, _a, automaticWithdrawal, _b, withdrawalFrequency, partner, sender, ixs, commitment, recipientPublicKey, mintPublicKey, metadata, _c, escrowTokens, senderTokens, recipientTokens, streamflowTreasuryTokens, partnerPublicKey, partnerTokens, hash, tx;
            var _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        mint = streamParams.tokenId, start = streamParams.start, period = streamParams.period, cliff = streamParams.cliff, canTopup = streamParams.canTopup, cancelableBySender = streamParams.cancelableBySender, cancelableByRecipient = streamParams.cancelableByRecipient, transferableBySender = streamParams.transferableBySender, transferableByRecipient = streamParams.transferableByRecipient, _a = streamParams.automaticWithdrawal, automaticWithdrawal = _a === void 0 ? false : _a, _b = streamParams.withdrawalFrequency, withdrawalFrequency = _b === void 0 ? 0 : _b, partner = streamParams.partner;
                        sender = solanaExtendedConfig.sender;
                        if (!sender.publicKey) {
                            throw new Error("Sender's PublicKey is not available, check passed wallet adapter!");
                        }
                        ixs = [];
                        commitment = typeof this.commitment == "string" ? this.commitment : this.commitment.commitment;
                        recipientPublicKey = new web3_js_1.PublicKey(recipient.recipient);
                        mintPublicKey = new web3_js_1.PublicKey(mint);
                        metadata = web3_js_1.Keypair.generate();
                        _c = __read(web3_js_1.PublicKey.findProgramAddressSync([buffer_1.Buffer.from("strm"), metadata.publicKey.toBuffer()], this.programId), 1), escrowTokens = _c[0];
                        return [4 /*yield*/, (0, utils_1.ata)(mintPublicKey, sender.publicKey)];
                    case 1:
                        senderTokens = _e.sent();
                        return [4 /*yield*/, (0, utils_1.ata)(mintPublicKey, recipientPublicKey)];
                    case 2:
                        recipientTokens = _e.sent();
                        return [4 /*yield*/, (0, utils_1.ata)(mintPublicKey, constants_1.STREAMFLOW_TREASURY_PUBLIC_KEY)];
                    case 3:
                        streamflowTreasuryTokens = _e.sent();
                        partnerPublicKey = partner ? new web3_js_1.PublicKey(partner) : constants_1.STREAMFLOW_TREASURY_PUBLIC_KEY;
                        return [4 /*yield*/, (0, utils_1.ata)(mintPublicKey, partnerPublicKey)];
                    case 4:
                        partnerTokens = _e.sent();
                        ixs.push((0, instructions_1.createStreamInstruction)({
                            start: new bn_js_1.default(start),
                            depositedAmount: recipient.amount,
                            period: new bn_js_1.default(period),
                            amountPerPeriod: recipient.amountPerPeriod,
                            cliff: new bn_js_1.default(cliff),
                            cliffAmount: recipient.cliffAmount,
                            cancelableBySender: cancelableBySender,
                            cancelableByRecipient: cancelableByRecipient,
                            automaticWithdrawal: automaticWithdrawal,
                            transferableBySender: transferableBySender,
                            transferableByRecipient: transferableByRecipient,
                            canTopup: canTopup,
                            name: recipient.name,
                            withdrawFrequency: new bn_js_1.default(automaticWithdrawal ? withdrawalFrequency : period),
                        }, this.programId, {
                            sender: sender.publicKey,
                            senderTokens: senderTokens,
                            recipient: new web3_js_1.PublicKey(recipient.recipient),
                            metadata: metadata.publicKey,
                            escrowTokens: escrowTokens,
                            recipientTokens: recipientTokens,
                            streamflowTreasury: constants_1.STREAMFLOW_TREASURY_PUBLIC_KEY,
                            streamflowTreasuryTokens: streamflowTreasuryTokens,
                            partner: partnerPublicKey,
                            partnerTokens: partnerTokens,
                            mint: new web3_js_1.PublicKey(mint),
                            feeOracle: constants_1.FEE_ORACLE_PUBLIC_KEY,
                            rent: web3_js_1.SYSVAR_RENT_PUBKEY,
                            timelockProgram: this.programId,
                            tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                            associatedTokenProgram: spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID,
                            withdrawor: constants_1.WITHDRAWOR_PUBLIC_KEY,
                            systemProgram: web3_js_1.SystemProgram.programId,
                        }));
                        return [4 /*yield*/, this.connection.getLatestBlockhash(commitment)];
                    case 5:
                        hash = _e.sent();
                        tx = (_d = new web3_js_1.Transaction({
                            feePayer: sender.publicKey,
                            blockhash: hash.blockhash,
                            lastValidBlockHeight: hash.lastValidBlockHeight,
                        })).add.apply(_d, __spreadArray([], __read(ixs), false));
                        tx.partialSign(metadata);
                        return [2 /*return*/, { tx: tx, metadata: metadata }];
                }
            });
        });
    };
    return SolanaStreamClient;
}(BaseStreamClient_1.BaseStreamClient));
exports.default = SolanaStreamClient;
